import React, { Component } from 'react';
import '../css/App.css';
import '../css/fonts.css';
import '../css/addlightness.css';

/*
import cloud1 from '../img/cloud1.png'
import cloud2 from '../img/cloud2.png'
import cloud3 from '../img/cloud3.png'
*/


export class MobileApps extends Component {
  constructor(props) {
    super(props)

    this.EXPANDED_FONT_SIZE = 50
    this.NORMAL_FONT_SIZE = 34
    this.MAX_FONT_DIFF = this.EXPANDED_FONT_SIZE - this.NORMAL_FONT_SIZE

    //this.ANIM_DECREMENT = 0.05
    this.ANIM_DECREMENT = 0.12
    this.ANIM_STEPS = 1.0 / this.ANIM_DECREMENT
    this.ANIM_INTERVAL_MS = 15
    this.ANIM_DURATION = this.ANIM_STEPS * this.ANIM_INTERVAL_MS


    this.state = {
      showApps: false,
      animWasTriggered: false,
      animInProgress: false,
      animPct: 1.0,
      animStartTime: null,
      animElapsed: 0,
      whichAppHovered: "none",
    }

    this.animIntervalId = null;

    this.startAnimation = this.startAnimation.bind(this)
    this.stopAnimation = this.stopAnimation.bind(this)
    this.doAnimInterval = this.doAnimInterval.bind(this)

    this.hovered = this.hovered.bind(this)
    this.unHovered = this.unHovered.bind(this)

    this.renderApps = this.renderApps.bind(this)
    this.getAnimatedDivStyle = this.getAnimatedDivStyle.bind(this)
    this.getExpandedParentStyle = this.getExpandedParentStyle.bind(this)
    this.getElementStyle = this.getElementStyle.bind(this)

    this.parentDiv = this.parentDiv.bind(this)
    this.renderAppDescriptionBox = this.renderAppDescriptionBox.bind(this)
  }


  hovered(elem) {
    //console.log("MobileApps hovered() for id: " + elem.target.id)
    if ( elem.target.id === "mobile-apps-parent" ) {
      if ( ! this.state.animWasTriggered ) {
        this.startAnimation()
      }
    } else if ( elem.target.id === "futbol-anchor" ) {
      this.setState({
        whichAppHovered: "futbol"
      })
    } else if ( elem.target.id === "happy-camper-anchor" ) {
      this.setState({
        whichAppHovered: "camper"
      })
    }
  }


  unHovered(elem) {
    //
    // 22 May 2019
    // multiple unHover events happen at the bottom of the mobile apps container
    // any one of them needs to kill the expansion
    //
    //console.log("MobileApps unHovered() for elem: "+ elem.target.id)
    const triggers = [ "mobile-apps-expanded-container", "bottom-apps-div", "happy-camper-anchor" ]
    if ( triggers.includes(elem.target.id ) ) {
      this.props.unBlurFunc()
      this.stopAnimation()
      this.setState({
        showApps: false,
        animWasTriggered: false,
        whichAppHovered: "none"
      })
    }
  }


  getAnimatedDivStyle() {
    let fontSize = this.NORMAL_FONT_SIZE

    if ( this.state.animInProgress ) {
      const currentDiffSize = this.MAX_FONT_DIFF * ( 1 - this.state.animPct )
      //console.("animating with currentDiffSize: " + currentDiffSize)
      fontSize = this.NORMAL_FONT_SIZE + currentDiffSize
      //console.log("animating with fontSize: " + fontSize)
    } else if ( this.state.animWasTriggered  ) {
      fontSize = this.EXPANDED_FONT_SIZE
    }

    const out = {
      display: "flex",
      flexDirection: "column",
      boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
      background: "#ffffff",
      //border: "2px solid #443321",
      border: "2px solid #1F557D",
      padding: "10px",
      paddingTop: "15px",
      fontFamily: "BeyondInfinity",
      fontSize: `${fontSize}px`,
      marginLeft: "5px",
      marginRight: "5px",
    }
    return out
  }

  getExpandedParentStyle() {
    const out = {
      display: "flex",
      flexDirection: "column",
      boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
      background: "#ffffff",
      border: "2px solid #443321",
      padding: "10px",
      paddingTop: "15px",
      marginLeft: "5px",
      marginRight: "5px",
    }
    return out
  }

  getElementStyle() {
    const elementStyle = {
      display: "flex",
      flexDirection: "column",
      background: "#fff",
      fontFamily: "BeyondInfinity",
      fontSize: `${this.EXPANDED_FONT_SIZE}px`,
      marginLeft: "5px",
      marginRight: "5px",
    }

    return elementStyle
  }



  parentDiv() {
    //console.log("parentDiv() with trigger: " + this.props.whichBoxWasTriggered)

    let divStyle = this.props.unBlurredStyle

    /*
    if ( this.state.animWasTriggered ) {
      divStyle = this.getAnimatedDivStyle()
    } else if ( this.props.whichBoxWasTriggered !== "none" ) {
      divStyle = this.props.blurredStyle
    }
    */

    //console.log("parentDiv divStyle: " + JSON.stringify(divStyle))

    return (
      <div id="mobile-apps-parent"
        style={divStyle}
        onMouseOver={ this.hovered }
        onMouseLeave={ this.unHovered }
      >
        Mobile Apps
      </div>
    )
  }

  doAnimInterval() {
    //console.log("doAnimInterval() id: " + this.animIntervalId + " elapsed: " + this.state.animElapsed + " duration: " + this.ANIM_DURATION)

    if ( this.state.animElapsed >= this.ANIM_DURATION ) {
      //console.log("animPct <= 0")
      this.stopAnimation()
    } else {
      // issues with when number gets close to 0. Maybe a JS float problem.
      let newPct = this.state.animPct - this.ANIM_DECREMENT
      let newElapsedTime = this.state.animElapsed + this.ANIM_INTERVAL_MS
      if ( newPct < 0.01 ) {
        newPct = 0.0
      }
      //console.log(`animation interval decremented animPct: ${newPct}`)
      this.setState({
        animPct: newPct,
        animElapsed: newElapsedTime,
      })
    }
  }

  startAnimation() {
    if ( ! this.state.animWasTriggered ) {
      //console.log("startAnimation() with duration: " + this.ANIM_DURATION)

      this.props.blurFunc("mobile-apps")

      this.animIntervalId = setInterval(() =>
        this.doAnimInterval(),
        this.ANIM_INTERVAL_MS
      )

      this.setState({
        animWasTriggered: true,
        animInProgress: true,
        animStartTime: Date.now(),
      })
    }
  }

  stopAnimation(elem) {
    //console.log("stopAnimation() for animIntervalId: " + this.animIntervalId)

    clearInterval(this.animIntervalId)

    this.setState({
      showApps: true,
      animInProgress: false,
      animStartTime: null,
      animElapsed: 0,
      animPct: 1.0,
    })
  }

  renderApps() {
    return (
      <div
        id="mobile-apps-expanded-container"
        style={ this.getExpandedParentStyle() }
        onMouseLeave={ this.unHovered }
      >
        <div
          id="bottom-apps-div"
          style={this.getElementStyle()}
        >
          <a
            href="/hc"
            id="hydrazine-anchor"
            onMouseOver={ this.hovered }
          >
            React Hydrazine
          </a>
        </div>

        {/*
        <div className="mobile-apps-element-header">
          Mobile Apps
        </div>
        */}
        <div
          style={this.getElementStyle()}
        >
          <a
            href="/futbol"
            id="futbol-anchor"
            onMouseOver={ this.hovered }
          >Futbol Data Client</a>
        </div>
        <div
          id="bottom-apps-div"
          style={this.getElementStyle()}
        >
          <a
            href="/hc"
            id="happy-camper-anchor"
            onMouseOver={ this.hovered }
          >
            Happy Camper
          </a>
        </div>

      </div>
    )
  }


  renderAppDescriptionBox() {
    //console.log("renderAppDescriptionBox()")
    const descriptions = {
      'futbol' : `
        A mobile UI for soccer statistics and historical data from football-data.org.
      `,
      'camper' : `
        Easy registration + check-in for youth camping trips.
      `,
      'auth0' : `
        Some boilerplate for integrating Auth0 with a React Native app.
        Integrates Router and Redux based navigation.
      `,
    }

    const appNames = {
      'camper': 'Happy Camper',
      'futbol': 'Futbol Data Client',
      'auth0': 'Auth0 Template'
    }

    return (
      <div className="app-description-box">
        <h4>{ appNames[ this.state.whichAppHovered] }</h4>
        { descriptions[this.state.whichAppHovered] }
      </div>
    )
  }


  render() {

    return (
      <div>
        <div>
          { this.state.showApps
              ? this.renderApps()
              : this.parentDiv()
          }
        </div>
        <div>
          { this.state.whichAppHovered !== "none"
              ? this.renderAppDescriptionBox()
              :null
          }
        </div>
      </div>
    )
  }
}
